module.exports = __webpack_public_path__ + "static/media/img124.703e67b1.jpg";